var reguaFio = new Swiper(".regua-fio-wraper.swiper", {
  slidesPerView: 3,
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: true,
  },
  updateOnWindowResize: true,
  centeredSlides: false,
  breakpoints: {
    0: {
      slidesPerView: 1,
      pagination: {
        el: '.regua-fio.swiper-pagination',
        clickable: true,
      },
    },
    480: {
      slidesPerView: 1,
      pagination: {
        el: '.regua-fio.swiper-pagination',
        clickable: true,
      },
    },
    670: {
      slidesPerView: 1,
      pagination: {
        el: '.regua-fio.swiper-pagination',
        clickable: true,
      },
    },
    768: {
      slidesPerView: 3
      // Sem paginação acima desse breakpoint
    },
    1024: {
      slidesPerView: 3
      // Sem paginação acima desse breakpoint
    }
  },
});
